import { useState } from 'react';
import type { Translator } from '@/i18n';
import { Icon } from './Icon';
import { copyInviteLink, copyRoomId, shareInvite } from './invite-actions';

interface Props {
  t: Translator['t'];
  roomId: string;
}

/** Поділитися кімнатою. Формат посилання спільний із мобільними клієнтами. */
export function InvitePanel({ t, roomId }: Props): React.JSX.Element {
  const [open, setOpen] = useState(false);
  const [notice, setNotice] = useState<string | null>(null);

  return (
    <div className="invite">
      <button
        type="button"
        className="invite__toggle"
        onClick={() => {
          setOpen(!open);
          setNotice(null);
        }}
      >
        <Icon name="person_add" size={18} />
        {t('invite')}
      </button>

      {open && (
        <div className="invite__sheet">
          <button
            type="button"
            className="invite__action"
            onClick={() => {
              void shareInvite(t, roomId, 'menu').then((outcome) => {
                if (outcome !== 'shared' && outcome !== 'cancelled') setNotice(outcome);
              });
            }}
          >
            <Icon name="share" size={20} />
            {t('share')}
          </button>
          <button
            type="button"
            className="invite__action"
            onClick={() => {
              void copyInviteLink(t, roomId, 'menu').then(setNotice);
            }}
          >
            <Icon name="link" size={20} />
            {t('copyLink')}
          </button>
          <button
            type="button"
            className="invite__action"
            onClick={() => {
              void copyRoomId(t, roomId, 'menu').then(setNotice);
            }}
          >
            <Icon name="content_copy" size={20} />
            {t('copyRoomId')}
          </button>
          {notice !== null && <p className="invite__notice">{notice}</p>}
        </div>
      )}
    </div>
  );
}
